module.exports = __webpack_public_path__ + "img/clase2.aaf72e50.png";